import styled from "styled-components";

export const ButtonLayout = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;
